(function(){
    'use strict'

    angular
    .module('app.empresasFumigadoras')
    .controller('empresasFumigadoras.List', List);

    List.$inject = ['$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService'];

    function List($animationsSrv, ApiBaseService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        ApiBaseService.remoteController = 'api/Empresas-Fumigadoras'

        const companiaId = UserInfoService.getCompaniaId();

        var vm = this;

        vm.collection = [];
        vm.title = 'Empresas Fumigadoras';

        vm.goToEdit = function(data){
            
            var path = '/editar-empresa-fumigadora/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.goToEditPiloto = function(empresaFumigadora, linea){
            
            var path = '/editar-empresa-fumigadora-piloto/' + empresaFumigadora.id;

            if(linea){
                $location.path(path + '/' + linea.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){
            ApiBaseService.remoteController = 'api/Empresas-Fumigadoras'
            var promise = ApiBaseService.getAll([companiaId]);

            promise
            .then(function(collection){
                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        vm.delete = function(data){
            ApiBaseService.remoteController = 'api/Empresas-Fumigadoras'
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                vm.collection = vm.collection.filter(function(g) {
                    return g.id !== data.id;
                });
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        vm.deletePiloto = function(data){
            ApiBaseService.remoteController = 'api/Empresas-Fumigadoras/Pilotos'
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                const item = vm.collection.find((c)=>c.id == data.empresaFumigadoraId);

                if(item)
                {
                    item.pilotos = item.pilotos.filter(function(g) {
                    return g.id !== data.id;
                    });
                }
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

    }
})();